import { Navigate } from 'react-router-dom';
import { Flex, Spin } from 'antd';
import { LANDING_ENABLED } from '../config/constants';
import { LOGIN_PATH } from '../pages/publics/Landing/landingConstants';
import { useAuthStore } from '../store/useAuthStore';
import { getDefaultHomePath } from '../utils/isProfile';

interface LandingRouteProps {
  element: JSX.Element;
}

const LandingRoute = ({ element }: LandingRouteProps) => {
  const { authenticated, sessionLoading, loading, user } = useAuthStore();

  if (loading) {
    return (
      <Flex justify="center" align="center" style={{ height: '100vh' }}>
        <Spin size="large" />
      </Flex>
    );
  }

  if (!sessionLoading && authenticated && user) {
    return <Navigate to={getDefaultHomePath(user)} replace />;
  }

  if (!LANDING_ENABLED) {
    return <Navigate to={LOGIN_PATH} replace />;
  }

  return element;
};

export default LandingRoute;
